<template>
  <div>
    <h1 class="mb-8 font-bold text-3xl">
      <inertia-link class="text-indigo-400 hover:text-indigo-600" :href="route('products.searchProduct')">Prezzo Prodotti</inertia-link>
      <span class="text-indigo-400 font-medium">/</span> Cerca
    </h1>
    <div class="bg-white rounded-md shadow overflow-hidden max-w-5xl">
      <form @submit.prevent="store">
        <div class="p-8 -mr-6 -mb-8 flex flex-wrap">
          <text-input v-model="form.sku" :error="form.errors.sku" class="pr-6 pb-8 w-full lg:w-1/3" label="SKU" ref="skuInput"/>
        </div>
        <div class="px-8 py-4 bg-gray-50 border-t border-gray-100 flex justify-end items-center">
          <loading-button :loading="form.processing" class="btn-indigo" type="submit">Cerca Prodotto</loading-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import SelectInput from '@/Shared/SelectInput'
import LoadingButton from '@/Shared/LoadingButton'

export default {
  metaInfo: { title: 'Cerca Prodotto' },
  components: {
    LoadingButton,
    SelectInput,
    TextInput,
  },
  layout: Layout,
  props: {
    batches: Array,
  },
  remember: 'form',
  data() {
    return {
      form: this.$inertia.form({
        sku: null,
      }),
    }
  },
  mounted() {
    // Imposta il focus sull'input SKU quando la pagina è caricata
    this.$refs.skuInput.$el.querySelector('input').focus()
  },
  methods: {
    store() {
      if (navigator.onLine) {
        this.form.get(this.route('products.editPrice', this.form.sku))
      } else {
        this.$page.props.flash.error = 'Controllare la connessione e ricaricare la pagina'
      }
    },
  },
}
</script>
